@if (ronaStartedAt$ | async; as ronaStartedAt) {
  <div class="rona-state">
    <nimbus-user-tp-capacity-button></nimbus-user-tp-capacity-button>
    <span class="rona-state-content">
      {{ TranslationKeys.GeneralRona | translate }}
      <span>{{ baseDate$ | async | dateDifference: ronaStartedAt | durationFormat: 'mm:ss' }}</span>
    </span>
    <span class="button-wrapper">
      <button [disabled]="stopDisabled$ | async" (click)="stop()" id="btn-stop" nimbusPrimaryIconButton>
        <i [nimbusIcon]="Icons.CLOSE" iconWeight="regular"></i>
        <ng-container>
          <nimbus-tooltip [text]="TranslationKeys.GeneralStop | translate"></nimbus-tooltip>
        </ng-container>
      </button>
    </span>
  </div>
}
